export const HOME_CLIENT_VIDEO_REVIEW = {
  eyebrow: "Client Story",
  title: "The Right Team Makes",
  titleAccent: "All the Difference",
  subtitle:
    "Building from zero takes more than execution—you need a partner who understands your vision, challenges assumptions early, and ships with clarity. Hear it directly from a founder we worked with.",
  category: "Social dining & event hosting platform",
  youtubeVideoId: "k2hSuzDJ6ao",
  quote:
    "I cannot recommend Kaival and his team more. Their technical expertise and foresight—being able to see problems ahead before they occur and push back when something isn't a good idea—is exactly what you want in a developer.",
  supportingLine:
    "You need a team that meets deadlines, provides valuable input, and sees around corners you can't without technical expertise. Kaival and his team deliver on all of that.",
  author: {
    name: "Sasha De Jong",
    role: "Owner, AtMyCasa",
  },
  caseStudyHref: "/case-studies/event-hosting-solution",
  caseStudyLabel: "View Case Study",
};

export function getYoutubeEmbedSrc(videoId: string, autoplay = false): string {
  const params = new URLSearchParams({
    rel: "0",
    modestbranding: "1",
    ...(autoplay ? { autoplay: "1" } : {}),
  });
  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
}
